import * as THREE from "three";
import { gsap } from "gsap";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

const canvas = document.querySelector("#world");
const title = document.querySelector(".content__title");
const subtitle = document.querySelector(".content__subtitle");
const buttons = document.querySelectorAll(".content__link");

// First of all we create a scene
const scene = new THREE.Scene();

// Create this utility object with sizes. It will be used for the operations below
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

// Handle resizing behaviour
window.addEventListener("resize", () => {
  // Update the sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update the camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update the renderer
  renderer.setSize(sizes.width, sizes.height);
});

// Handle fullscreen on double click
window.addEventListener("dblclick", () => {
  const fullScreenElement =
    document.fullscreenElement || document.webkitFullscreenElement;

  if (!fullScreenElement) {
    if (canvas.requestFullscreen) {
      canvas.requestFullscreen();
    } else if (canvas.webkitRequestFullscreen) {
      canvas.webkitRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }
});

// Create a camera, very much similar to a real camera: the nearer you are, the bigger you see. This is the 'fov' (Field Of View) parameter.
// Then we pass in the aspect ratio of the camera: in this case we want a fullscreen camera, so we put innerWidth and innerHeight
const camera = new THREE.PerspectiveCamera(65, sizes.width / sizes.height);
// We move a little outside the camera, that as default is positioned inside our geometry.
camera.position.z = 3;
// We move a little on the right the camera.
camera.position.x = -1;
// We add the camera to the scene
scene.add(camera);

// Here we create a texture loader: the texture is the 'material' that our geometry will put on, just like clothes
const textureLoader = new THREE.TextureLoader();
// Now we load our custom texture
const matcapTexture = textureLoader.load(
  "https://bruno-simon.com/prismic/matcaps/3.png"
);

// Here we define our object and its geometry. This particular one (TorusKnotGeometry) will create an infinite knot.
const geometry = new THREE.TorusKnotGeometry(0.5, 0.2, 200, 30);
// Now we use the texture we have loaded before
const material = new THREE.MeshMatcapMaterial({
  matcap: matcapTexture,
  transparent: true,
  opacity: 0,
});
// Everything is blended up as a mesh
const mesh = new THREE.Mesh(geometry, material);
// The mesh is now added to the scene
scene.add(mesh);

// // Now we add the controls through OrbitControls
// const controls = new OrbitControls(camera, canvas);
// // This will enable the 'easing' while controlling the mesh
// controls.enableDamping = true;

// We create the renderer for the dom here
const renderer = new THREE.WebGLRenderer({ canvas: canvas });
// Now its time to define the sizes of our canvas: in this case it's fullscreen
renderer.setSize(sizes.width, sizes.height);
// We set our device pixel ratio in order to render a better object. We limit to 2 because a higher number is useless and leads to performance issues
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const cursor = { x: 0, y: 0 };
const tl = gsap.timeline({ paused: true, delay: 0.8, easing: "Back.out(2)" });

tl.from(title, { opacity: 0, y: 20 })
  .from(subtitle, { opacity: 0, y: 20 }, "-=.3")
  .from(
    buttons,
    { stagger: { each: 0.2, from: "start" }, opacity: 0, y: 20 },
    "-=.3"
  )
  .to(material, { opacity: 1 }, "-=.2");

window.addEventListener("mousemove", (_event) => {
  cursor.x = _event.clientX / sizes.width - 0.5;
  cursor.y = _event.clientY / sizes.height - 0.5;
});

// We instantiate this variable with the built-in method for clock. This will be used in order to maintain the FPS regardless of the pc of the user
const clock = new THREE.Clock();

// We make use of the RAF in order to update every millisecond the mesh rotation by 0.01 and let it rotate automatically
const tick = () => {
  window.requestAnimationFrame(tick);

  // It's the time elapsed since the first time clock gets instantiated
  const elapsedTime = clock.getElapsedTime();

  const cameraX = cursor.x - 1;
  const cameraY = -cursor.y;

  // We now use the elapsedTime variable in order to be sure everyone will have the same results
  mesh.rotation.y = elapsedTime / 2;

  // These instructions will let the mash make a circular soft wave
  mesh.position.x = Math.sin(elapsedTime) / 8;
  mesh.position.y = Math.cos(elapsedTime) / 8;

  camera.position.x += (cameraX - camera.position.x) / 45;
  camera.position.y += (cameraY - camera.position.y) / 45;

  // controls.update();
  renderer.render(scene, camera);
};
tick();

tl.play();
